module.exports = __webpack_public_path__ + "img/154.a12e3448.jpg";